/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../Fixes';
import Builder from '../../../../../../Builder';
import './multipass';
import './flag_groups';
import '../../message/context';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "feature": {
        "nested": {
          "relay": {
            "nested": {
              "flags": {
                "nested": {
                  "v2": {
                    "nested": {
                      "message": {
                        "nested": {
                          "SquareToken": {
                            "fields": {
                              "squareTokenType": {
                                "type": ".squareup.feature.relay.flags.v2.message.SquareTokenType",
                                "id": 1,
                                "rule": "optional"
                              },
                              "token": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "SquareTokensFlags": {
                            "fields": {
                              "defaultUserContext": {
                                "type": ".squareup.feature.relay.flags.v2.message.DefaultUserContextType",
                                "id": 1,
                                "rule": "optional"
                              },
                              "flagGroups": {
                                "type": ".squareup.feature.relay.flags.v2.message.FlagGroups",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "SquareTokensGroup": {
                            "fields": {
                              "squareMobileDevice": {
                                "type": ".squareup.feature.relay.flags.message.SquareMobileDevice",
                                "id": 1,
                                "rule": "optional"
                              },
                              "squareTokens": {
                                "type": ".squareup.feature.relay.flags.v2.message.SquareToken",
                                "id": 3,
                                "rule": "repeated"
                              },
                              "squareTokensFlags": {
                                "type": ".squareup.feature.relay.flags.v2.message.SquareTokensFlags",
                                "id": 2,
                                "rule": "repeated"
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.SquareToken && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.SquareTokensFlags && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.SquareTokensGroup) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE SquareToken @ squareup/feature/relay/flags/v2/message/square_tokens.proto at 13:1
 */
export const SquareToken = $root.lookupType('squareup.feature.relay.flags.v2.message.SquareToken');
fixType(SquareToken, {
  squareTokenType: { required: true },
});
Builder.createAndAttachToType(SquareToken);
/**
 * SOURCE SquareTokensFlags @ squareup/feature/relay/flags/v2/message/square_tokens.proto at 18:1
 */
export const SquareTokensFlags = $root.lookupType('squareup.feature.relay.flags.v2.message.SquareTokensFlags');
fixType(SquareTokensFlags);
Builder.createAndAttachToType(SquareTokensFlags);
/**
 * SOURCE SquareTokensGroup @ squareup/feature/relay/flags/v2/message/square_tokens.proto at 23:1
 */
export const SquareTokensGroup = $root.lookupType('squareup.feature.relay.flags.v2.message.SquareTokensGroup');
fixType(SquareTokensGroup);
Builder.createAndAttachToType(SquareTokensGroup);
